module.exports = __webpack_public_path__ + "static/media/mountadex-macbook-site-index.d09fc1eb.jpg";